import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { ATMobilityBenefitOptionsDTORefundTypeEnum } from 'probonio-shared-ui/api';
import { BenefitAttribute, BenefitColumnsExtensionInterface } from '../../../../extension/interface/benefit-columns.extension.interface';
import i18n from '../../../../lang';

export class ATMobilityBenefitColumnsExtension extends BenefitColumnsExtensionInterface {
  getBenefitAttributes: () => BenefitAttribute[] = () => [
    {
      id: 'atMobilityBudgetPeriod',
      accessorFn: value => value.atMobilityOptions,
      header: 'AT_MOBILITY.fields.budgetPeriod',
      renderer: value => {
        if (!value || typeof value !== 'object') return null;
        const options = value as { refundType?: string; limit?: number };
        if (typeof options.limit !== 'number') return null;
        const shortKey =
          options.refundType === ATMobilityBenefitOptionsDTORefundTypeEnum.Yearly
            ? 'benefitsModule:AT_MOBILITY.fields.refundTypeOptions.YEARLY_SHORT'
            : 'benefitsModule:AT_MOBILITY.fields.refundTypeOptions.MONTHLY_SHORT';
        return `${i18n.t('common:money', { money: options.limit })} / ${i18n.t(shortKey)}`;
      },
    },
    {
      id: 'atMobilityAllowGroupTickets',
      accessorFn: value => value.atMobilityOptions?.allowGroupTickets,
      header: 'AT_MOBILITY.fields.allowGroupTickets.label',
      renderer: value =>
        typeof value === 'boolean' ? (
          value ? (
            <CheckIcon color="success" fontSize="small" />
          ) : (
            <CloseIcon color="error" fontSize="small" />
          )
        ) : null,
    },
  ];
}
